export default __webpack_public_path__ + "static/media/Scale-Image.ec5c195e.jpg";